import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

type BeniHotelApiResponse = {
  available_comparison_sets: string[];
  id: number;
};

export default class BeniHotelSerializer extends ApplicationSerializer {
  // The API returns a flat object { id, available_comparison_sets }.
  // EmberData expects { "benchmark-insight/hotel": { ... } }, so we wrap it.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: BeniHotelApiResponse,
    id: string | number,
    requestType: string,
  ) {
    const normalizedPayload = {
      'benchmark-insight/hotel': payload,
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super.normalizeResponse(
      store,
      primaryModelClass,
      normalizedPayload,
      id,
      requestType,
    );
  }
}
